import { render, staticRenderFns } from "./infoImageSlider.vue?vue&type=template&id=2d067f9a&scoped=true&"
import script from "./infoImageSlider.vue?vue&type=script&lang=js&"
export * from "./infoImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./infoImageSlider.vue?vue&type=style&index=0&id=2d067f9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d067f9a",
  null
  
)

export default component.exports